module.exports = __webpack_public_path__ + "static/img/logo--pokeapi.3fa7220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo--pokeapi.png
// module id = U4O2
// module chunks = 1